import { useEffect, useState } from "react";
import { useRestaurant } from "../contexts/RestaurantContext";
import onlineOrderingService from "../services/onlineOrderingService";

const EMPTY = { banners: [], offers: [], loaded: false };

export default function useOnlineOrderingPromos({ enabled = true } = {}) {
  const { restaurantSlug, locationId } = useRestaurant();
  const [state, setState] = useState(EMPTY);

  useEffect(() => {
    if (!enabled || !restaurantSlug) {
      setState({ banners: [], offers: [], loaded: !restaurantSlug });
      return undefined;
    }

    let cancelled = false;
    setState((prev) => ({ ...prev, loaded: false }));

    onlineOrderingService
      .getOnlineOrderingPromos(restaurantSlug, locationId)
      .then((result) => {
        if (cancelled) return;
        setState({
          banners: result.banners || [],
          offers: result.offers || [],
          loaded: true,
        });
      })
      .catch(() => {
        if (cancelled) return;
        setState({ banners: [], offers: [], loaded: true });
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, restaurantSlug, locationId]);

  return state;
}
